import { gql } from '@apollo/client';

export const FETCH_ALERT_RESPONSE_CATEGORY = gql`
    query fetchAlertResponseCategory {
        lookup {
            alertResponseCategories {
                id
                name
                slug
            }
        }
    }
`;
